export * from './ArrowCLeftIcon';
export * from './ArrowCLeftIcon16Light';
export * from './ArrowCLeftIcon16Regular';
export * from './ArrowCLeftIcon16Solid';
export * from './ArrowCLeftIcon20Light';
export * from './ArrowCLeftIcon20Regular';
export * from './ArrowCLeftIcon20Solid';
export * from './ArrowCLeftIcon24Regular';
export * from './ArrowCLeftIcon24Solid';
export * from './ArrowCLeftIcon32Regular';
export * from './ArrowCLeftIcon64Regular';
